import { makeStyles } from '@rbx/ui';
import React, { FunctionComponent } from 'react';

type GlobalLogoProps = {
  width?: number | undefined;
  height?: number | undefined;
};

const useGlobalLogoStyles = makeStyles()(theme => ({
  logo: {
    color: theme.palette.text.primary
  }
}));

const GlobalLogo: FunctionComponent<GlobalLogoProps> = ({ width, height }) => {
  const {
    classes: { logo }
  } = useGlobalLogoStyles();

  return (
    <svg
      className={logo}
      width={width}
      height={height}
      viewBox='0 0 1622 300'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M195.505 194.616L242.182 280.047H155.574L116.162 207.039H78.8242V280.047H0V21.2487H144.165C203.802 21.2487 241.664 54.3476 241.664 113.871C241.664 152.173 224.032 179.611 195.505 194.616ZM78.8242 88.509V139.751H134.831C151.425 139.751 161.797 129.917 161.797 113.871C161.797 97.8257 151.425 88.509 134.831 88.509H78.8242ZM492.657 299.176L256.703 235.512L319.969 0L437.946 31.8322L555.923 63.6644L492.657 299.176ZM448.059 125.776L382.199 107.66L364.567 173.395L430.427 191.516L448.059 125.776ZM826.109 207.039C826.109 256.728 794.476 280.047 745.21 280.047H590.674V21.2487H740.025C789.29 21.2487 820.923 46.6109 820.923 91.1242C820.923 119.074 810.552 137.713 790.846 150.653C813.144 160.455 826.109 180.129 826.109 207.039ZM667.423 83.3603V121.662H718.736C732.737 121.662 741.035 115.451 741.035 101.994C741.035 89.5714 732.737 83.3603 718.736 83.3603H667.423ZM667.423 217.935H724.986C738.469 217.935 746.275 210.689 746.275 198.261C746.275 184.809 738.496 178.598 724.986 178.598H667.423V217.935ZM865.002 21.2487H943.816V203.421H1056.87V280.047H864.992L865.002 21.2487ZM1346.77 150.653C1346.77 177.27 1338.86 203.288 1324.05 225.419C1309.23 247.55 1288.17 264.799 1263.54 274.984C1238.9 285.17 1211.79 287.835 1185.63 282.642C1159.48 277.45 1135.45 264.633 1116.6 245.812C1097.74 226.992 1084.9 203.013 1079.7 176.908C1074.5 150.803 1077.17 123.744 1087.37 99.1536C1097.58 74.5632 1114.86 53.5455 1137.03 38.7582C1159.2 23.9709 1185.27 16.0782 1211.94 16.0782C1229.65 16.043 1247.2 19.499 1263.57 26.2478C1279.94 32.9967 1294.82 42.9057 1307.35 55.4062C1319.87 67.9068 1329.8 82.753 1336.57 99.0931C1343.33 115.433 1346.8 132.946 1346.77 150.626V150.653ZM1267.94 150.653C1267.94 118.557 1242.53 93.1946 1211.94 93.1946C1181.34 93.1946 1155.93 118.557 1155.93 150.653C1155.93 182.75 1181.34 208.106 1211.94 208.106C1242.53 208.106 1267.94 182.712 1267.94 150.626V150.653ZM1536.57 146.507L1621.62 280.047H1527.73L1481.08 203.933L1432.85 280.047H1337.43L1426.11 149.607L1344.69 21.2487H1438.56L1481.6 91.1242L1523.09 21.2487H1616.43L1536.57 146.507Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default GlobalLogo;
